import { EventEmitter } from 'events';

const dtEmitter = new EventEmitter();
export default dtEmitter;
